<template>
  <MChart
    :series="metricSeries"
    :options="chartOptions"
    height="60px"
  />
</template>

<script>
  import MChart from 'legacy/modules/common/components/MChart/MChart';
  import getDateRange from 'utils/dateRange/getDateRange';
  import moment from 'moment-wrapper';
  import formatNumber from 'legacy/modules/common/components/MNumeric/formatNumber';
  import insertMissedOrderedObjects from 'utils/object/insertMissedOrderedObjects';

  const NO_DATA_MIN_X_VALUE = 0;
  const NO_DATA_MAX_X_VALUE = 10;

  export default {
    name: 'StatsWidgetChart',
    components: {MChart},
    props: {
      statistics: {
        type: Array,
        default: Array
      },
      metric: {
        type: String,
        default: ''
      },
      metricType: {
        type: String,
        default: 'integer'
      },
      dateStart: {
        type: String,
        default: ''
      },
      dateEnd: {
        type: String,
        default: ''
      }
    },
    computed: {
      dateSeries () {
        return getDateRange(new Date(this.dateStart), new Date(this.dateEnd)).
          map(i => moment(i).
            formatDateApi());
      },
      noData () {
        return this.statistics.length === 0;
      },
      metricSeries () {
        const data = insertMissedOrderedObjects(
          this.statistics,
          this.dateSeries,
          'date',
          (d) => ({
            date: d,
            [this.metric]: 0
          })
        );
        return [
          {
            name: this.metric,
            data: data.map(i => i[this.metric])
          }
        ];
      },
      chartOptions () {
        const config = {
          padding: {
            left: 0,
            right: 0,
            top: 0
          },
          stroke: {
            width: 3
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          fill: {
            type: 'solid',
            colors: ['#DEEEFF']
          },
          colors: ['#3890F3'],
          chart: {
            type: 'area',
            stacked: false,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            enabled: true,
            followCursor: true,
            style: {
              fontSize: '12px'
            },
            x: {
              show: true,
              formatter: (xValue, {dataPointIndex}) => moment(this.dateSeries[dataPointIndex]).formatDate()
            },
            y: {
              show: true,
              formatter: yValue => formatNumber(yValue, this.metricType, {withCurrencySymbol: true}),
              title: {
                formatter: () => ''
              }
            }
          },
          legend: {
            show: false
          },
          yaxis: {
            show: false
          },
          xaxis: {
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: {
              show: false
            }
          }
        };

        if (this.noData) {
          config.yaxis.min = NO_DATA_MIN_X_VALUE;
          config.yaxis.max = NO_DATA_MAX_X_VALUE;
        }
        return config;
      }
    }
  };
</script>
